/**
 * Infrastructure Container Module
 */
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { TaskInitApi } from '../apis/task-init-api';
import { TaskInitApiImpl } from '../apis/impls/task-init-api-impl';
import { RecommendTsApi } from '../apis/recommend-ts-api';
import { RecommendTsApiImpl } from '../apis/impls/recommend-ts-api-impl';
import { TsSearchApi } from '../apis/ts-search-api';
import { TsSearchApiImpl } from '../apis/impls/ts-search-api-impl';
import { TaskHistoryApi } from '../apis/task-history-api';
import { TaskHistoryApiImpl } from '../apis/impls/task-history-api-impl';
import { FindSectionsApi } from '../apis/find-sections-api';
import { FindSectionsApiImpl } from '../apis/impls/find-sections-api-impl';
import { ClaimChartApi } from '../apis/claim-chart-api';
import { ClaimChartApiImpl } from '../apis/impls/claim-chart-api-impl';
import { ExportApi } from '../apis/export-api';
import { ExportApiImpl } from '../apis/impls/export-api-impl';
import { TsPdfUrlApi } from '../apis/ts-pdf-url-api';
import { TsPdfUrlApiImpl } from '../apis/impls/ts-pdf-url-api-impl';
import { NoveltySearchApi } from '../apis/novelty-search-api';
import { NoveltySearchApiImpl } from '../apis/impls/novelty-search-api-impl';

export const infrastructureModule = new ContainerModule((bind) => {
    bind<TaskInitApi>(TaskInitApi).to(TaskInitApiImpl).inSingletonScope();
    bind<RecommendTsApi>(RecommendTsApi).to(RecommendTsApiImpl).inSingletonScope();
    bind<TsSearchApi>(TsSearchApi).to(TsSearchApiImpl).inSingletonScope();
    bind<TaskHistoryApi>(TaskHistoryApi).to(TaskHistoryApiImpl).inSingletonScope();
    bind<FindSectionsApi>(FindSectionsApi).to(FindSectionsApiImpl).inSingletonScope();
    bind<ClaimChartApi>(ClaimChartApi).to(ClaimChartApiImpl).inSingletonScope();
    bind<ExportApi>(ExportApi).to(ExportApiImpl).inSingletonScope();
    bind<TsPdfUrlApi>(TsPdfUrlApi).to(TsPdfUrlApiImpl).inSingletonScope();
    bind<NoveltySearchApi>(NoveltySearchApi).to(NoveltySearchApiImpl).inSingletonScope();
});
